import React from 'react';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import {
  Button,
  Card,
  Container,
  FormHelperText,
  Grid,
  LinearProgress
} from '@material-ui/core';
import Header from './Header';
import MyRadioButton from './MyRadioButton';

function TrainingGoal({ formData, setFormData, nextPage, prevPage, goToContact }) {
  return (
    <React.Fragment>
      <Header title="Which best describes your current training goal?" />
      <Container maxWidth="md" style={{ height: '500px', padding: '1rem' }}>
        <Card raised>
          <Formik
            initialValues={formData}
            validationSchema={yup.object({
              trainingGoal: yup.string()
                .required('Please select an option')
            })}
            onSubmit={async (values, actions) => {
              // console.log(JSON.parse(JSON.stringify(values)));
              actions.setSubmitting(true);

              setFormData(values);

              if (values.trainingGoal === 'weightlifting') {
                nextPage();
              } else {
                goToContact();
              }

            }}
          >
            {formik => (
              <Form>
                <Container maxWidth="sm" style={{ padding: '1rem' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <MyRadioButton
                        label="I train to compete in Olympic Weightlifting"
                        name="trainingGoal"
                        type="radio"
                        value="weightlifting"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MyRadioButton
                        label="I want to improve my Olympic lifts for CrossFit"
                        name="trainingGoal"
                        type="radio"
                        value="crossfit"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MyRadioButton
                        label="I want to be more athletic for my team sport"
                        name="trainingGoal"
                        type="radio"
                        value="sportsPerformance"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MyRadioButton
                        label="I train for fun and/or to stay in shape"
                        name="trainingGoal"
                        type="radio"
                        value="fitness"
                      />
                    </Grid>
                    {!!formik.errors.trainingGoal && (
                      <Grid item xs={12}>
                        <FormHelperText error>{formik.errors.trainingGoal}</FormHelperText>
                      </Grid>
                    )}
                    <Grid item xs={4}>
                      <Button disabled={formik.isSubmitting} variant="contained" onClick={prevPage} fullWidth>Back</Button>
                    </Grid>
                    <Grid item xs={8} style={{ margin: 'auto' }}>
                      {formik.isSubmitting ? (
                        <LinearProgress />
                      ) : (
                        <Button variant="contained" color="primary" type="submit" fullWidth>Next</Button>
                      )}
                    </Grid>
                  </Grid>
                </Container>
              </Form>
            )}
          </Formik>
        </Card>
      </Container>
    </React.Fragment>
  );
}

export default TrainingGoal;